import {Routes, RouterModule} from '@angular/router';
import { CanActivateViaAuthService } from '../shared/services/can-activate-via-auth.service';
const mainLayoutRoutes:Routes = [{
  path: '',
  children: [
    {
      path:'',
      pathMatch: 'full',
      redirectTo: 'discover'
    },
    {
      path: 'profile/:id',
      canActivate:[CanActivateViaAuthService],
      loadChildren: './musician-profile/musician-profile.module#MusicianProfileModule',
    },
    {
      path: 'profile/settings/:id',
      canActivate:[CanActivateViaAuthService],
      loadChildren: './musician-profile-settings/musician-profile-settings.module#MusicianProfileSettingsModule',
    },
    {
      path: 'discover',
      canActivate:[CanActivateViaAuthService],
      loadChildren: './discover/discover.module#DiscoverModule',
    },
    {
      path: 'band/:id',
      canActivate:[CanActivateViaAuthService],
      loadChildren: './band-profile/band-profile.module#BandProfileModule',
    },
    {
      path: 'band/settings/:id',
      canActivate:[CanActivateViaAuthService],
      loadChildren: './band-profile-settings/band-profile-settings.module#BandProfileSettingsModule',
    },
    {
      path: 'connections',
      canActivate:[CanActivateViaAuthService],
      loadChildren: './connections/connections.module#ConnectionsModule',
    },
    {
      path: 'messages',
      canActivate:[CanActivateViaAuthService],
      loadChildren: './conversations/conversations.module#ConversationsModule',
    },
    {
      path: 'auditions',
      canActivate:[CanActivateViaAuthService],
      loadChildren: './auditions/auditions.module#AuditionsModule',
    },
    {
      path: 'search',
      canActivate:[CanActivateViaAuthService],
      loadChildren: './search/search.module#SearchModule',
    },
    {
      path: 'bands',
      canActivate:[CanActivateViaAuthService],
      loadChildren: './bands-list/bands-list.module#BandsListModule',
    },
    {
      path: 'login',
      loadChildren: '../shared/user-login/user-login.module#UserLoginModule',
    },
  ]
}];

export const MainLayoutRouting = RouterModule.forChild(mainLayoutRoutes);
